import OpenGraph from "./OpenGraph.svelte";
import { Node, mergeAttributes } from "@tiptap/core";
import { NodePasteRule, SvelteSSRRenderer } from "$components/editor/utils";
import { allValidEmbedURLs } from "../../Embeds/utils";
import { SvelteNodeViewRenderer } from "svelte-tiptap";
import { type MarkdownSerializerState } from "prosemirror-markdown";
import { type Node as PMNode } from "@tiptap/pm/model";

const URL_REGEX = /^(http(s)?:\/\/)(.+)?$/g;

export const OpenGraphBlock = Node.create({
  name: "open-graph",

  group: "block",

  draggable: true,

  addAttributes() {
    return {
      url: {
        default: null,
      },
      host: {
        default: null,
      },
      openGraph: {
        default: null,
      },
    };
  },

  addNodeView() {
    return SvelteNodeViewRenderer(OpenGraph);
  },

  parseHTML() {
    return [
      {
        tag: "open-graph",
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    return SvelteSSRRenderer("open-graph", OpenGraph, {
      node,
      attributes: mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
    });
  },

  addPasteRules() {
    return [
      NodePasteRule({
        find: URL_REGEX,
        type: this.type,
        rule: "append",
        getAttributes: (match) => {
          if (!isValidUrl(match[0])) {
            return false;
          }
          return { url: match[0] };
        },
      }),
    ];
  },

  addStorage() {
    return {
      markdown: {
        serialize: (state: MarkdownSerializerState, node: PMNode) => {
          const url = node.attrs.url;
          state.write(`[${url}](${url})\n\n`);
        },
      },
    };
  },
});

function isValidUrl(url: string) {
  // check if the url is not an embed url
  for (let i = 0; i < allValidEmbedURLs.length; i++) {
    if (allValidEmbedURLs[i](url)) return false;
  }

  return url.match(URL_REGEX);
}
